import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { CustomerOrderStateType, ApiGetDataStatus } from '@redux/types'
import { OrderType } from '@schemas'

// initial state
const initialState: CustomerOrderStateType = {
	triggerInitCustomerOrderPage: false,

	// product
	orderList: [],
	orderListStatus: 'init',
}

const slice = createSlice({
	name: 'customerOrder',
	initialState,
	reducers: {
		TRIGGER_INIT_CUSTOMER_ORDER_PAGE: (
			state: CustomerOrderStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerInitCustomerOrderPage = action.payload
		},

		// product
		ORDER_LIST: (state: CustomerOrderStateType, action: PayloadAction<OrderType[]>) => {
			state.orderList = action.payload
		},
		ORDER_LIST_STATUS: (
			state: CustomerOrderStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.orderListStatus = action.payload
		},
	},
})

export const customerOrderActions = slice.actions
export default slice.reducer
